import { put } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Adds temporary lights to the current mode and selects them.
 *
 * @param root0 - The action.
 * @param root0.payload - The lights to add.
 * @yields Dispatches actions to add temporary lights and update selection.
 */
function* addLights({ payload }) {
    try {
        const { lights } = payload;
        yield put(actions.map.values.mode.addTemporaryLights(lights));
        yield put(actions.map.general.selectLights(lights, "multiple"));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on changing mode:", err);
    }
}

export default addLights;
